import { render, staticRenderFns } from "./MenuSubNav.vue?vue&type=template&id=1f15c917&"
import script from "./MenuSubNav.vue?vue&type=script&lang=js&"
export * from "./MenuSubNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports